import { INKLE_WEBSITE_URL } from "./base";

export const TASK_ARCHIVED = "Filing Archived";
export const TASK_UNARCHIVED = "Filing Unarchived";

export const CANT_EDIT_BECAUSE_TASK_ARCHIVED =
  "You can't edit because This filing is archived.";

export const TASK_SUCCESSFULLY_FILED = "Successfully Filed";

// Task filters
export const ONGOING = "ONGOING";
export const COMPLETED = "COMPLETED";
export const ARCHIVED = "ARCHIVED";
export const ALL = "ALL";
export const NEW = "NEW";
export const ONGOING_WITH_NOT_STARTED = "ONGOING_WITH_NOT_STARTED";
export const BOTH = "BOTH";

export const SUBMITTED = "SUBMITTED";

export const ADDRESS_AUTOFILL_VERSION_2_0 = "2.0";

export const BANK_ACCOUNTS = "bank_accounts";
export const ADDRESSES = "addresses";
export const AUTHORIZED_PERSONS = "authorized_persons";

export const PAID_TASK = "PAID";
export const UNPAID_TASK = "UNPAID";

// sort options
export const MY_FILING_SORT_OPTIONS = [
  { id: 1, title: "Default", value: "Default" },
  {
    id: 2,
    title: "Oldest Filing in progress",
    value: "Oldest FIP",
    sortKey: "OLD_BY_FILING_IN_PROGRESS",
  },
  {
    id: 3,
    title: "Latest Filing in progress",
    value: "Latest FIP",
    sortKey: "NEW_BY_FILING_IN_PROGRESS",
  },
];

//etd filter keys
export const UN_SET = "UN_SET";
export const LESS_THAN_30_DAYS = "LESS_THAN_30_DAYS";
export const MORE_THAN_30_DAYS = "MORE_THAN_30_DAYS";
export const OVER_DUE = "OVER_DUE";

// etd filter options
export const ETD_FILTER_OPTIONS = [
  {
    value: UN_SET,
    label: "Unset ETD",
  },
  {
    value: LESS_THAN_30_DAYS,
    label: "Less Than 30 Days remaining",
  },
  {
    value: MORE_THAN_30_DAYS,
    label: "More Than 30 Days remaining",
  },
  {
    label: "Overdue",
    value: OVER_DUE,
  },
];

export const BANK_ACCESS_HELP = `${INKLE_WEBSITE_URL}help/giving-bank-access-to-team-inkle-as-bookkeeper`;

export const MISSING_INFORMATION_FORM_7004_FLAG =
  "missing_information_form_7004_flag";
export const MISSING_BUSINESS_FINANCIALS_FORM_7004_FLAG =
  "missing_business_financials_form_7004_flag";
export const PROFITABLE = "profitable";
export const NON_PROFITABLE = "non_profitable";
export const BOOKS_COMPLETED = "books_completed";
export const BOOKS_IN_PROGRESS = "books_in_progress";
export const BOOKS_NOT_STARTED = "books_not_started";

export const ALL_BANK_CONNECTED = "ALL_BANK_CONNECTED";
export const ANY_BANK_DISCONNECTED = "ANY_BANK_DISCONNECTED";
export const ALL_ACCESS_AVAILABLE = "COMPLETE";
export const ANY_ACCESS_MISSING = "PARTIAL";

export const BOOKKEEPING_SERVICE_TYPES = {
  BOOKKEEPING_CATCHUP: "BOOKKEEPING_CATCHUP",
  MONTHLY_BOOKKEEPING: "MONTHLY_BOOKKEEPING",
  ANNUAL_CATCHUP: "ANNUAL_CATCHUP",
} as const;

export const BANK_CONNECTION_OPTIONS = [
  {
    value: ALL_BANK_CONNECTED,
    label: "All banks connected",
  },
  {
    value: ANY_BANK_DISCONNECTED,
    label: "Any bank disconnected",
  },
];

export const ACCOUNTANT_ACCESS_OPTIONS = [
  {
    value: ALL_ACCESS_AVAILABLE,
    label: "All accesses available",
  },
  {
    value: ANY_ACCESS_MISSING,
    label: "Any access missing",
  },
];

export const SERVICE_FILTER_OPTIONS = [
  {
    label: "Bookkeeping Catchup",
    value: BOOKKEEPING_SERVICE_TYPES.BOOKKEEPING_CATCHUP,
  },
  {
    label: "Monthly Bookkeeping",
    value: BOOKKEEPING_SERVICE_TYPES.MONTHLY_BOOKKEEPING,
  },
  {
    label: "Annual Catchup",
    value: BOOKKEEPING_SERVICE_TYPES.ANNUAL_CATCHUP,
  },
];

export const EQUAL = "EQUAL";
export const GREATER_THAN = "GREATER_THAN";
export const LESSER_THAN = "LESSER_THAN";
export const GREATER_THAN_EQUAL = "GREATER_THAN_EQUAL";
export const LESSER_THAN_EQUAL = "LESSER_THAN_EQUAL";

// Task file status constants
export const TASK_FILE_STATUS = {
  UPLOADING: "UPLOADING",
  ERROR: "ERROR",
  UPLOADED: "UPLOADED",
  DELETING: "DELETING",
} as const;

// Task category types
export const TASK_CATEGORY_TYPES = {
  TAX: "TAX",
  BOOKS: "BOOKS",
  RND: "RND",
  INTRA_GROUP: "INTRA_GROUP",
  SALES_TAX: "SALES_TAX",
} as const;

// Dashboard status constants
export const DASHBOARD_STATUS = {
  ACTION_REQUIRED: "ACTION_REQUIRED",
  UPCOMING_DEADLINES: "UPCOMING_DEADLINES",
  PAYMENT_PENDING: "PAYMENT_PENDING",
  ONGOING: "ONGOING",
} as const;

export const TASK_COMPLETED_FILE_DOC_TYPE = {
  FILED_COPY: "Filed Copy",
  ACKNOWLEDGEMENT_COPY: "Acknowledgement Copy",
  OTHERS: "Others",
} as const;

// Task source constants
export const TASK_SOURCE = {
  LAUNCHED_TASK: "LAUNCHED_TASK",
  CART: "CART",
  ALARMS: "ALARMS",
} as const;

// Cart status constants
export const CART_STATUS = {
  ARCHIVED: "ARCHIVED",
  IN_CART: "IN_CART",
} as const;

// Task slider tabs
export const TASK_SLIDER_TABS = {
  DETAILS: "DETAILS",
  CHAT: "CHAT",
} as const;

export const FILTER_FILING_ALL = "ALL";
export const FILTER_FILING_PAYMENT_PENDING = "PAYMENT_PENDING";
export const FILTER_FILING_ADD_DETAILS = "ADD_DETAILS";
export const FILTER_FILING_PROCESSING = "PROCESSING";
export const FILTER_FILING_ONGOING = "ONGOING";
export const FILTER_FILING_COMPLETED = "COMPLETED";
export const FILTER_FILING_ARCHIVED = "ARCHIVED";

export const COMPLETED_FILTER_KEYS = "COMPLETED, AMENDMENT_COMPLETED";
export const PROCESSING_KEYS = "PROCESSING, AMENDMENT";
export const ONGOING_KEYS = "PROCESSING, AMENDMENT, ADD_DETAILS";

export const FILTER_FILING_PENDING_ON_ME = "PENDING_ON_ME";

export const FILTER_FILING_STATUS = "FILING_STATUS";

export const FILTER_HIGHLIGHT_TASK_ALARM_UUID = "taskId";

export type TaskFilterKeys =
  | "FILING_STATUS"
  | "START_DATE"
  | "END_DATE"
  | "SELECT_PERIOD"
  | "FILINGS"
  | "PENDING_ON_ME";

export type FilingStatusType =
  | typeof FILTER_FILING_ALL
  | typeof FILTER_FILING_PAYMENT_PENDING
  | typeof FILTER_FILING_ADD_DETAILS
  | typeof FILTER_FILING_PROCESSING
  | typeof FILTER_FILING_ONGOING
  | typeof FILTER_FILING_COMPLETED
  | typeof FILTER_FILING_ARCHIVED
  | null;

export type TaskFilterValues = {
  FILING_STATUS: FilingStatusType;
  START_DATE: string;
  END_DATE: string;
  SELECT_PERIOD: string;
  FILINGS: string[];
  PENDING_ON_ME: boolean;
};
